//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
let d=[[[0,"ParentObjectType",1,0],[0,"PropertyOf",1,0]],[[["propertyOf","groupName","propertyName"],"Add",{},3,0]],[]];
SPLM.AME.AddPropertyColumnBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.AddPropertyColumnBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.AddPropertyColumnBuilder.Types = Object.freeze({
    "Objects" : "Objects", "Targets" : "Targets", "Sources" : "Sources", "Connections" : "Connections", "ObjectPorts" : "ObjectPorts", "TargetPorts" : "TargetPorts", "SourcePorts" : "SourcePorts", "ObjectParents" : "ObjectParents", "TargetParents" : "TargetParents", "SourceParents" : "SourceParents", "ConnectionParents" : "ConnectionParents"});

SPLM.AME.AddPropertyColumnBuilder.ParentObjectTypes = Object.freeze({
    "Function" : "Function", "Location" : "Location", "Product" : "Product", "Automation" : "Automation"});

export default SPLM;